import { Link } from 'react-router-dom';
import { Link as MUILink } from '@mui/material';
import { useState } from 'react';
import { Auth } from './auth-form';
import { trpc } from '../../trpc';
import { formatTRPCError } from '../../foundation/shared/utils/trpc-error';
import { useNotifications } from '@client/foundation/notifications/notifications.hook';

export const Signup = () => {
  const [error, setError] = useState('');
  const { notify } = useNotifications();

  const mutation = trpc.users.createUser.useMutation({
    onError(error) {
      const { fieldErrors, formError } = formatTRPCError(error);

      setError('Invalid email or password');
    }
  });

  const handleSubmit = async ({
    email,
    password
  }: {
    email: string;
    password: string;
  }) => {
    await mutation.mutateAsync({
      email,
      password
    });
    notify({
      type: 'success',
      message: 'Account has been created'
    });
  };

  return (
    <Auth submitLabel="Signup" error={error} onSubmit={handleSubmit}>
      <Link to={'/login'} style={{ alignSelf: 'center' }}>
        <MUILink>Login</MUILink>
      </Link>
    </Auth>
  );
};
